import {
  REMOVE_PENDING_SELF_PROMOTION,
  SET_ANSWER_SELF_PROMOTION_ERROR,
  SET_ANSWERING_SELF_PROMOTION,
  SET_PENDING_SELF_PROMOTIONS,
  SET_PENDING_SELF_PROMOTIONS_ERROR,
  SET_PENDING_SELF_PROMOTIONS_LOADING,
} from '../actions/selfPromotionActionTypes';

const initialState = {
  pending: [],
  isLoading: false,
  error: null,
  answering: false,
  answerError: null,
};

export default function selfPromotionReducer(state = initialState, action) {
  switch (action.type) {
    case SET_PENDING_SELF_PROMOTIONS_LOADING:
      return {
        ...state,
        isLoading: action.loading,
      };

    case SET_PENDING_SELF_PROMOTIONS:
      return {
        ...state,
        pending: action.pending,
      };

    case SET_PENDING_SELF_PROMOTIONS_ERROR:
      return {
        ...state,
        error: action.error,
      };

    case SET_ANSWERING_SELF_PROMOTION:
      return {
        ...state,
        answering: action.answering,
      };

    case SET_ANSWER_SELF_PROMOTION_ERROR:
      return {
        ...state,
        answerError: action.error,
      };

    case REMOVE_PENDING_SELF_PROMOTION:
      return {
        ...state,
        pending: state.pending.filter(
          (item) => item.configId !== action.configId,
        ),
      };

    default:
      return state;
  }
}
